import { CreatePost } from "./CreatePost";
import { PostList } from "./PostList";

export function FeedPosts() {
  return (
    <div className="space-y-4">
      {/* Create Post Block */}
      <CreatePost />

      {/* Posts List */}
      <PostList />
    </div>
  );
}
